"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateDashboard = void 0;
const gs = require("@ivanlog/gs");
const com = require("../com/tmpls");
const StatePaged_1 = require("./abstracts/StatePaged");
class StateDashboard extends StatePaged_1.StatePaged {
    //private _tiles:Array<com.CmpInfoTile>=[];
    constructor() {
        super(com.PageVX, "ValidatorX DApp", true);
        this.page.ctrls.cmpHeroVX.ctrls.blockTags.show();
        this.page.ctrls.widgetVXApp.setStatusCmp(this.page.ctrls.widgetVXStatus);
        this.page.ctrls.widgetInfoVXS.ctrls.aMain.el.href = '/?state=dashboard&vxs=1';
        this.page.ctrls.widgetInfoVX.ctrls.aMain.el.href = '/';
        this.page.ctrls.widgetVXSApp.ctrls.btnTabVX.onclick = () => this._openVX();
        this._refreshHandler = () => __awaiter(this, void 0, void 0, function* () {
            yield this._refreshAsync();
        });
    }
    start() {
        const _super = Object.create(null, {
            start: { get: () => super.start }
        });
        return __awaiter(this, void 0, void 0, function* () {
            // let link = document.querySelector("link[rel~='icon']") as any;
            // if (!link) {
            //     link = document.createElement('link');
            //     link.rel = 'icon';
            //     document.head.appendChild(link);
            // }
            // link.href = 'images/favicon_open.svg';
            this.gui.showPage(this.page);
            // const calc = new VXControlView();
            // await calc.refreshAsync();
            // this.page.ctrls.blocks.append(calc);
            // calc.ctrls.blockTiles.append(this._addTile(
            //     "Step 1",
            //     "Connect wallet, input PLS stake amount, confirm transaction",
            //     "To stake Pulse click 'Connect wallet' button, use slider or input field to enter exact PLS staking amount, click 'Stake PLS' button and sign the transaction"
            // ));
            // calc.ctrls.blockTiles.append(this._addTile(
            //     "Step 2",
            //     "After cooldown is over use 'Withdraw uPLS' button to get liquid staking token",
            //     "Withdaw uPLS tokens after a 2 day cooldown period. uPLS is the liquid staking token that empowers you to remain liquid while staking your PLS"
            // ));
            // calc.ctrls.blockTiles.append(this._addTile(
            //     "Step 3",
            //     "Add 'uPLS to Wallet' to see uPLS in the wallet",
            //     "To add uPLS to your wallet click 'Add uPLS to Wallet'. You can also add uPLS manually, see contract address and more by clicking '+'"
            // ));
            // this._tilesAnimAsync();
            this._refreshAsync();
            return _super.start.call(this);
        });
    }
    afterStart() {
        const _super = Object.create(null, {
            afterStart: { get: () => super.afterStart }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.app.chain.onChangeAccount.addHandler(this._refreshHandler);
            this.page.ctrls.widgetInfoVXS.ctrls.aMain.onclick = (e) => {
                gs.events.stop(e);
                this._openVXS();
            };
            this.page.ctrls.widgetInfoVX.ctrls.aMain.onclick = (e) => {
                gs.events.stop(e);
                this._openVX();
            };
            yield _super.afterStart.call(this);
        });
    }
    stop() {
        const _super = Object.create(null, {
            stop: { get: () => super.stop }
        });
        return __awaiter(this, void 0, void 0, function* () {
            this.app.chain.onChangeAccount.removeHandler(this._refreshHandler);
            yield _super.stop.call(this);
        });
    }
    _openVX() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.widgetInfoVXS.show();
            this.page.ctrls.widgetInfoVX.hide();
            this.page.ctrls.widgetVXApp.show();
            this.page.ctrls.widgetVXSApp.hide();
        });
    }
    _openVXS() {
        return __awaiter(this, void 0, void 0, function* () {
            this.page.ctrls.widgetInfoVXS.hide();
            this.page.ctrls.widgetInfoVX.show();
            this.page.ctrls.widgetVXApp.hide();
            this.page.ctrls.widgetVXSApp.show();
            this.page.ctrls.widgetVXSApp.loadAsync();
        });
    }
    _refreshAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const ctrls = this.page.ctrls;
            yield ctrls.widgetVXApp.refreshAsync();
            ctrls.cmpHeroVX.showAPR(ctrls.widgetVXApp.vxAPR);
        });
    }
}
exports.StateDashboard = StateDashboard;
StateDashboard.StateName = "dashboard";
//# sourceMappingURL=StateDashboard.js.map